import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { VisibilityIcon } from "@icarius-icons/index";
import { Typography } from "@material-ui/core";
import useCoursesMaster from "./useCoursesMaster";
import CourseFormDialog from "./courseFormDialog";
import CoursePage from "./coursePage";
import DuplicateFormDialog from "./duplicateFormDialog";
import UploadFileDialog from "./uploadFileDialog";
import TreeViewDialog from "./treeDialog";
import RelatedSkillsDialog from "./relatedSkillsDialog";
import ExtensionIcon from '@material-ui/icons/Extension';
import paths from "@icarius-router/paths";

const CoursesMaster = ({ history }) => {

  const {
    ownColumnDef,
    courses,
    skillList,
    userFieldsDefinition,
    courseFormData,
    courseTree,
    isLoading,
    state,
    handlers,
  } = useCoursesMaster();

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      type={"goBack"}
      onClick={() => history.push(paths.trainingAndDevelopment)}
    />
  )

  const createButton = () => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateCourseForm()}
      type={"add"}
    />
  )

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateCourseForm(gridRef)}
      type={"edit"}
    />
  )

  const duplicateButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("duplicate")}
      onClick={() => handlers.handleOpenDuplicateCourseForm(gridRef)}
      type={"duplicate"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteCourseDialog(gridRef)}
      type={"delete"}
    />
  )

  const relatedSkillsButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("relatedSkills")}
      onClick={() => handlers.handleOpenRelatedSkillsDialog(gridRef)}
    >
      <ExtensionIcon />
    </CustomIconButton>
  )

  const exportButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("export")}
      onClick={() => handlers.handleExportCourse(gridRef)}
      type={"download"}
    />
  )

  const importButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("import")}
      onClick={() => handlers.handleOpenImportCourseDialog(gridRef)}
      type={"upload"}
    />
  )

  const viewTreeButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("viewVisualizationTree")}
      onClick={() => handlers.handleOpenTreeDialog(gridRef)}
    >
      <VisibilityIcon />
    </CustomIconButton>
  )

  return (
    <>
      {
        Boolean(!state.coursePageIsOpen) ?
          <CommonPage
            isLoading={isLoading}
            title={getLocalizedString("coursesMaster")}
            gridTitle={getLocalizedString("coursesMaster")}
            customHeader={() => <Typography className="whiteText">{getLocalizedString("clicToOpenModulesAndActivities")}</Typography>}
            ownColumnDef={ownColumnDef}
            rowData={courses}
            handleRowClick={handlers.handleOpenCoursePage}
            menuItems={[goBackButton, createButton, editButton, duplicateButton, deleteButton, relatedSkillsButton, exportButton, importButton, viewTreeButton]}
            hasExpand
            hasHelp
          >
            {
              state.courseFormIsOpen &&
              <CourseFormDialog
                open={state.courseFormIsOpen}
                readOnly={state.selectedCourse?.isInUse || false}
                data={courseFormData}
                skillList={skillList}
                userFieldsDefinition={userFieldsDefinition}
                isLoading={isLoading}
                submitCallback={courseFormData ? handlers.handleUpdateCourse : handlers.handleCreateCourse}
                invalidFiles={state.courseInvalidFiles}
                handleClearInvalidFiles={handlers.handleClearInvalidFiles}
                handleClose={handlers.handleCloseCourseForm}
              />
            }
            {
              state.relatedSkillsDialogIsOpen &&
              <RelatedSkillsDialog
                open={state.relatedSkillsDialogIsOpen}
                data={courseFormData}
                skillList={skillList}
                userFieldsDefinition={userFieldsDefinition}
                submitCallback={handlers.handleUpdateCourse}
                handleClose={handlers.handleCloseRelatedSkillsDialog}
              />
            }
            {
              state.duplicateCourseFormIsOpen &&
              <DuplicateFormDialog
                open={state.duplicateCourseFormIsOpen}
                title={getLocalizedString("duplicateCourse", { courseName: courseFormData.name })}
                submitCallback={handlers.handleDuplicateCourse}
                handleClose={handlers.handleCloseDuplicateCourseForm}
                isLoading={isLoading}
              />
            }
            {
              state.importCourseDialogIsOpen &&
              <UploadFileDialog
                open={state.importCourseDialogIsOpen}
                handleClose={handlers.handleCloseImportCourseDialog}
                isLoading={isLoading}
              />
            }
            {
              state.treeDialogIsOpen &&
              <TreeViewDialog
                open={state.treeDialogIsOpen}
                data={courseTree}
                handleClose={handlers.handleCloseTreeDialog}
              />
            }
          </CommonPage>
          :
          <CoursePage
            course={state.selectedCourse}
            handleGoBack={handlers.handleCloseCoursePage}
          />
      }
    </>
  )
}

export default CoursesMaster;